export default "__VITE_ASSET__C6tWmWZQ__"